<template>
  <!-- @mouseenter="handleMouseenter" -->
  <!-- @mouseleave="handleMouseleave" -->
  <!-- @mouseenter="hovered" -->
  <div
    ref="cont"
    class="ffccbox"
    @mouseenter="e => handleMousemove(e, 'immediate')"
    @mousemove="handleMousemove"
    @touchmove="handleMousemove"
    @mousedown="handleMousedown"
    @touchstart="handleMousedown"
    @mouseup="handleMouseup"
    @touchend="handleMouseup"
  >
    <!-- <div class="ffccbox_content"> -->
    <slot
      name="default"
      :coordinates="coordinates"
      :mousedownMs="mousedownMs"
    ></slot>
    <!-- :hovered="hovered" -->
    <!-- </div> -->
    <!-- <div
      class="ffccbox_elcursor"
      :class="elcursorClass || ''"
      :style="`top: ${coordinates.y_percent}%; left: ${coordinates.x_percent}%;${
        elcursorStyle || ''
      }`"
    > -->
    <!-- <slot
      name="elcursor"
    ></slot> -->
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  name: 'FollowCursorBox',
  props: {
    elcursorStyle: { type: String, default: '' },
    elcursorClass: { type: String, default: '' },
    speedIn: { type: Number, default: 10 },
    speedOut: { type: Number, default: 10 },
  },
  data() {
    return {
      coordinates: {
        y_percent: 0,
        x_percent: 0,
        x_px: 0,
        y_px: 0,
      },
      // hovered:false,

      startMove: 0,
      tmMiliseconds: 0,

      mousedownInterval: null,
      mousedownMs: 0,
    }
  },
  beforeUnmount() {
    // this.removeEventListeners()
    clearInterval(this.mousedownInterval)
    this.mousedownInterval = 0
    this.mousedownInterval = null
  },
  methods: {
    // handleMouseenter() {
    // this.addEventListeners()
    // },
    // handleMouseleave() {
    // this.removeEventListeners()
    // },
    // addEventListeners() {
    //   window.addEventListener('mousemove', this.handleMousemove)
    // },
    // removeEventListeners() {
    //   window.removeEventListener('mousemove', this.handleMousemove)
    // },
    handleMousedown() {
      clearInterval(this.mousedownInterval)
      this.mousedownInterval = setInterval(() => {
        this.mousedownMs += this.speedIn
      }, 1)
    },
    handleMouseup() {
      clearInterval(this.mousedownInterval)
      this.mousedownInterval = setInterval(() => {
        this.mousedownMs -= this.speedOut
        if (this.mousedownMs <= 0) {
          clearInterval(this.mousedownInterval)
          this.mousedownInterval = null
          this.mousedownMs = 0
        }
      }, 1)
    },
    handleMousemove(e, immediate) {
      // console.log(e)
      const {cont} = this.$refs
      const cont_rect = cont.getBoundingClientRect()

      if (Date.now() - this.startMove > 200) {
        this.tmMiliseconds = 0
      }

      this.startMove = Date.now()
      this.tmMiliseconds = Math.max(Math.min(this.tmMiliseconds + 1, 0), 200)
      // console.log(this.tmMiliseconds)

      if (e?.touches) {
        e = {
          clientX: e?.touches[0]?.clientX,
          clientY: e?.touches[0]?.clientY,
        }
      }
      const y = e.clientY - cont_rect.y
      const x = e.clientX - cont_rect.x

      const coordinates = {
        y_percent: (y / cont_rect.height) * 100,
        x_percent: (x / cont_rect.width) * 100,
        x_px: x,
        y_px: y,
      }

      // if (!this.tmMiliseconds || immediate) {
      //   this.setCoordinates(coordinates)
      //   return
      // }
      this.setCoordinates(coordinates)
      // setTimeout(() => {
      // }, this.tmMiliseconds)
    },
    setCoordinates(coordinates) {
      this.coordinates = coordinates
    },
  },
}
</script>
<style lang="scss" scoped>
.ffccbox {
  position: relative;
  // &_content {
  //   opacity: 0;
  //   //   position: absolute;
  //   transition: opacity 0.44s ease;
  // }
  // &:hover {
  //   .ffccbox_content {
  //     opacity: 1;
  //   }
  // }
}
</style>
